"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RightMenu = void 0;
var RightMenu_1 = require("./RightMenu");
Object.defineProperty(exports, "RightMenu", { enumerable: true, get: function () { return __importDefault(RightMenu_1).default; } });
